exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".error-e5cb4b51{color:#FF3940;padding:30px}.result-c70601f7{padding:30px}.code-c2019dc1{opacity:0.4}.highlightedCode-44f54958{opacity:1}.headLite-2796eb8d{font-weight:bold;margin-top:20px}\n", ""]);

// Exports
exports.locals = {
	"error": "error-e5cb4b51",
	"result": "result-c70601f7",
	"code": "code-c2019dc1",
	"highlightedCode": "highlightedCode-44f54958",
	"headLite": "headLite-2796eb8d"
};